export const version = "abstract-provider/5.2.0";
